export const CARRITO_EXPIRACION_MS = 24 * 60 * 60 * 1000;

export const getCarritoExpiraEn = (primerProductoAgregadoAt) => {
	if (!primerProductoAgregadoAt) {
		return null;
	}

	return Number(primerProductoAgregadoAt) + CARRITO_EXPIRACION_MS;
};

export const carritoEstaExpirado = (primerProductoAgregadoAt, now = Date.now()) => {
	const expiraEn = getCarritoExpiraEn(primerProductoAgregadoAt);

	if (!expiraEn) {
		return false;
	}

	return now >= expiraEn;
};

export const getPrimerProductoAgregadoAtDesdeExpiracion = (carritoExpiraAt) => {
	if (!carritoExpiraAt) {
		return null;
	}

	const expiraEn = Date.parse(String(carritoExpiraAt).replace(' ', 'T'));
	if (Number.isNaN(expiraEn)) {
		return null;
	}

	return expiraEn - CARRITO_EXPIRACION_MS;
};
